<template>
    <v-dialog v-model="model" max-width="600px" persistent>
        <v-card class="red darken-4">
            <v-card-text class="py-8">
                <div class="d-flex justify-center mb-4" v-if="img">
                    <div>
                        <v-img 
                            :src="require('@/assets/'+sum+'.png')"
                            width="200px">
                            </v-img>
                    </div>
                </div>
                <div class="px-4 white--text title text-center" v-html="text" style="line-height:1.2"></div>
            </v-card-text>

            <div class="d-flex justify-center align-center px-4 pt-2 pb-6">
                <v-btn text large class="amber darken-4 white--text" @click="$emit('accept')">CERRAR</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['model', 'text', 'img', 'sum']
}
</script>

